<template>
    <b-sidebar
     id="socials-form-sidebar"
     :visible="isSocialsFormSidebarActive"
     bg-variant="white"
     sidebar-class="sidebar-lg"
     shadow
     backdrop
     no-header
     right
     @shown="getData(socialsData)"
     @hidden="resetForm"
     @change="(val) => $emit('update:is-socials-form-sidebar-active', val)"
   >

   <template #default="{ hide }"> 
       <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
           <h5 class="mb-0">
               Socials  Form
           </h5>
   
           <feather-icon
               class="ml-1 cursor-pointer"
               icon="XIcon"
               size="16"
               @click="hide"
           />
       </div>
       <validation-observer
         #default="{ handleSubmit }"
         ref="refFormObserver"
       >
         <b-form
           class="p-2"
           @submit.prevent="handleSubmit(onSubmit)"
           @reset.prevent="resetForm"
         >
            <b-tabs v-model="tabIndex">
                <b-tab title="Content">
                  
                  <validation-provider
                    #default="validationContext"
                    name="category_id"
                    rules="required"
                  >
                    <b-form-group
                      label="Category"
                      label-for="category_id"
                    >
              
                      <v-select
                              id="category_id"
                              v-model="Data.category_id"
                              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                              label="title"
                              :reduce="(option) => option.id"
                              :options="catsData"
                      />
              
                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                  <validation-provider
                      #default="validationContext"
                      name="Title"
                      rules="required"
                    >
                    <b-form-group
                      label="Title"
                      label-for="title"
                    >
                      <b-form-input
                        id="title"
                        v-model="Data.title"
                        autofocus
                        :state="getValidationState(validationContext)"
                        trim
                        placeholder="Title"
                        @input="changeTitle"
                      />
        
                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
            <validation-provider
              #default="validationContext"
              name="slug"
              rules="required"
            >
              <b-form-group
                label="Slug"
                label-for="slug"
              >
                <b-form-input
                  id="slug"
                  v-model="Data.slug"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder="Slug"
                />
  
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            
            <validation-provider
              #default="validationContext"
              name="url"
              rules="required"
            >
              <b-form-group
                label="Url"
                label-for="url"
              >
                <b-form-input
                  id="url"
                  v-model="Data.url"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder="Url"
                />
  
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <validation-provider
              #default="validationContext"
              name="IsActive"
              rules="min:0"
            >
              <b-form-group
                label="Is Active"
                label-for="IsActive"
              >
              
                <b-form-checkbox
                id="isactive"
                                checked="true"
                                class="custom-control-success"
                                v-model="Data.is_active"
                                switch
                  />
  
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
                    
                </b-tab>
                <b-tab title="Image">
                    <div class="border rounded p-2 mb-2">
                      <h4 class="mb-1">
                        Banner Image
                      </h4>
                      <b-media
                        no-body
                        vertical-align="center"
                        class="flex-column flex-md-row"
                      >
                        <b-media-aside>
                          <b-img
                            ref="refBannerEl"
                            :src="Data.bannerImage"
                            height="110"
                            width="170"
                            class="rounded mr-2 mb-1 mb-md-0"
                          />
                        </b-media-aside>
                        <b-media-body>
                          <small class="text-muted">Required image resolution 1940x540, image size 10mb.</small>
                          <b-card-text class="my-50">
                           
                          </b-card-text>
                          <div class="d-inline-block">
                            <b-form-file
                              ref="refInputBannerEl"
                              v-model="Data.bannerFile"
                              accept=".jpg, .png, .gif, .webp,"
                              placeholder="Choose file"
                              @input="inputBannerRenderer"
                            />
                          </div>
                          <b-card-text class="my-50">
                            <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary" v-if="Data.banner_image" @click="revomeBanner">Remove Image</b-button>
                          </b-card-text>
                        </b-media-body>
                      </b-media>
                    </div>
                    <div class="border rounded p-2">
                      <h4 class="mb-1">
                        Featured Image 1
                      </h4>
                      <b-media
                        no-body
                        vertical-align="center"
                        class="flex-column flex-md-row"
                      >
                        <b-media-aside>
                          <b-img
                            ref="refPreviewEl"
                            :src="Data.featuredImage"
                            height="110"
                            width="170"
                            class="rounded mr-2 mb-1 mb-md-0"
                          />
                        </b-media-aside>
                        <b-media-body>
                          <small class="text-muted">Required image resolution 312x312, image size 3mb.</small>
                          <b-card-text class="my-50">
                           
                          </b-card-text>
                          <div class="d-inline-block">
                            <b-form-file
                              ref="refInputEl"
                              v-model="Data.portfolioFile"
                              accept=".jpg, .png, .gif, .webp,"
                              placeholder="Choose file"
                              @input="inputImageRenderer"
                            />
                          </div>
                          <b-card-text class="my-50">
                            <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary" v-if="Data.cover_image" @click="revomeImage">Remove Image</b-button>
                          </b-card-text>
                        </b-media-body>
                      </b-media>
                    </div>
                    <div class="border rounded p-2 mb-2">
                      <h4 class="mb-1">
                        Featured Image 2
                      </h4>
                      <b-media
                        no-body
                        vertical-align="center"
                        class="flex-column flex-md-row"
                      >
                        <b-media-aside>
                          <b-img
                            ref="refLogoEl"
                            :src="Data.logoImage"
                            height="110"
                            width="170"
                            class="rounded mr-2 mb-1 mb-md-0"
                          />
                        </b-media-aside>
                        <b-media-body>
                          <small class="text-muted">Required image resolution 192x192, image size 10mb.</small>
                          <b-card-text class="my-50">
                           
                          </b-card-text>
                          <div class="d-inline-block">
                            <b-form-file
                              ref="refInputLogoEl"
                              v-model="Data.logoFile"
                              accept=".jpg, .png, .gif, .webp,"
                              placeholder="Choose file"
                              @input="inputLogoRenderer"
                            />
                          </div>
                          <b-card-text class="my-50">
                            <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary" v-if="Data.logo_image" @click="revomeLogo">Remove Image</b-button>
                          </b-card-text>
                        </b-media-body>
                      </b-media>
                    </div>
                    

                </b-tab>
                <!--<b-tab title="gallery" v-if="socialsData" >
                  
                    <upload-form  v-if="tabIndex == 2" :socials-data.sync="socialsData" />
                </b-tab>
                -->
                <b-tab title="SEO">
                  
                    <validation-provider
                        #default="validationContext"
                        name="meta_title"
                        rules="min:0"
                    >
                        <b-form-group
                        label="Meta Title"
                        label-for="meta_title"
                        >
                        <b-form-input
                            id="meta_title"
                            v-model="Data.meta_title"
                            autofocus
                            :state="getValidationState(validationContext)"
                            trim
                            placeholder="Meta Title"
                        />
            
                        <b-form-invalid-feedback>
                            {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                        </b-form-group>
                    </validation-provider> 
                    <validation-provider
                        #default="validationContext"
                        name="meta_description"
                        rules="min:0"
                    >
                        <b-form-group
                        label="Meta Description"
                        label-for="meta_description"
                        >
                        <b-form-input
                            id="meta_description"
                            v-model="Data.meta_description"
                            autofocus
                            :state="getValidationState(validationContext)"
                            trim
                            placeholder="Meta Description"
                        />
            
                        <b-form-invalid-feedback>
                            {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                        </b-form-group>
                    </validation-provider>   
                    <validation-provider
                        #default="validationContext"
                        name="meta_keywords"
                        rules="min:0"
                    >
                        <b-form-group
                        label="Meta Keywords"
                        label-for="meta_keywords"
                        >
                        <b-form-input
                            id="meta_keywords"
                            v-model="Data.meta_keywords"
                            autofocus
                            :state="getValidationState(validationContext)"
                            trim
                            placeholder="Meta Keywords"
                        />
            
                        <b-form-invalid-feedback>
                            {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                        </b-form-group>
                    </validation-provider>      
                </b-tab>
            </b-tabs>
           


           <div class="d-flex mt-2">
             <b-button
               v-ripple.400="'rgba(255, 255, 255, 0.15)'"
               variant="primary"
               class="mr-2"
               type="submit"
             >
               Submit
             </b-button>
             <b-button
               v-ripple.400="'rgba(186, 191, 199, 0.15)'"
               type="button"
               variant="outline-secondary"
               @click="hide"
             >
               Cancel
             </b-button>
           </div>
         </b-form>
         
         
       </validation-observer>
   </template>
   </b-sidebar>
</template>
<script>
import { $themeConfig } from '@themeConfig'
 import {
   BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, BFormInvalidFeedback, BButton,BTabs, BTab
 } from 'bootstrap-vue'
 //upload
 import {
  BCard,BCardText,BMedia,BMediaAside,BMediaBody,BAvatar,BImg,BLink,BFormFile,BListGroup,BListGroupItem
 } from 'bootstrap-vue'
 import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'

 import { ValidationProvider, ValidationObserver } from 'vee-validate'
 import { ref } from '@vue/composition-api'
 import { required, alphaNum, email, password,confirmed } from '@validations'
 import formValidation from '@core/comp-functions/forms/form-validation'
 import Ripple from 'vue-ripple-directive'
 import vSelect from 'vue-select'
 import countries from '@/@fake-db/data/other/countries'
 import store from '@/store'
 import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
 import { useToast } from 'vue-toastification/composition'
 import UploadForm from './UploadForm.vue'


import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'

import { slugify } from '@/@fake-db/utils'

import { quillEditor } from 'vue-quill-editor'
export default {
   components: {
     BSidebar,
     BForm,
     BFormGroup,
     BFormInput,
     BFormTextarea,
     BFormCheckbox,
     BFormInvalidFeedback,
     BButton,
     BTabs, BTab,
     BCard,BCardText,BMedia,BMediaAside,BMediaBody,BAvatar,BImg,BLink,BFormFile,
     vSelect,
     quillEditor,
     // Form Validation
     ValidationProvider,
     ValidationObserver,
     UploadForm,
     BListGroup,BListGroupItem
   },
   directives: {
     Ripple,
   },
   model: {
     prop: 'isSocialsFormSidebarActive',
     event: 'update:is-socials-form-sidebar-active',
   },
   props: {
     isSocialsFormSidebarActive: {
       type: Boolean,
       required: true,
     },
    
     socialsData: {
       type: Object,
       required: false,
     },
   },
   setup(props, { emit }) {
    const {  appRef } = $themeConfig.app
       const toast = useToast()
       const catsData = ref([]);
      
       const userStorage = JSON.parse(localStorage.getItem('userData'));
       const getLocalSite = JSON.parse(localStorage.getItem('site'))
       const  tabIndex = ref(0);
       const blankData = {
           featuredImage:require('@/assets/images/no-image.png'),
           bannerImage:require('@/assets/images/no-image.png'),
           logoImage:require('@/assets/images/no-image.png'),
           cover_image:'',
           banner_image:'',
           categories:[],
           category_id:'',
           logo_image:'',
           created_by:userStorage.id,
           created_at:null,
           title: '',
           slug:'',
           url:'',
           year:'',
           client:'',
           country:'',
           status:'',
           sub_title:'',
           short_description:'',
           content1:'',
           content2:'',
           title_2:'',
           description:'',
           is_active:true,
           portfolioFile:null,
           bannerFile:null,
           logoFile:null,
           meta_title:'',
           meta_description:'',
           meta_keywords:'',
           ordering_count:0,
           sites_id: getLocalSite.id
       }
       const Data = ref(JSON.parse(JSON.stringify(blankData)))
       const resetData = () => {
           Data.value = JSON.parse(JSON.stringify(blankData))
       }
       store.dispatch('app-socials/fetchCats', {
        sites_id: getLocalSite.id
       })
      .then(response => {
        catsData.value = response.data.data
      })
       const getData = (data)=>{
        tabIndex.value =0;
        refPreviewEl.value.src = require('@/assets/images/no-image.png');
        refBannerEl.value.src = require('@/assets/images/no-image.png');
        refLogoEl.value.src = require('@/assets/images/no-image.png');
        
           if(data){
            //if(data.categories.length > 0){
            //  data.categories = data.categories.map((item)=>{
            //    return item.category_id;
            //  });
            //
            //}
                data.featuredImage = data.cover_image?data.fullpath:Data.value.featuredImage;
                data.bannerImage = data.banner_image?data.fullbannerpath:Data.value.bannerImage;
                data.logoImage = data.logo_image?data.fulllogopath:Data.value.logoImage;
               data.is_active = data.is_active?true:false;
               Data.value  = JSON.parse(JSON.stringify(data));
           }
       }
       const onSubmit = () => {
        let formData = new FormData();
            Data.value.is_active = Data.value.is_active?1:0;
            Data.value.path = '/var/www/html/uploadfiles/uploads/'+appRef+'/socials/';
            Data.value.savepath = 'uploads/'+appRef+'/socials/';
            for(const [key, value] of Object.entries(Data.value)) {
              formData.append(key, value);
             
            
            }
           if(Data.value.id){
             
               store.dispatch('app-socials/updateSocials', {formData:formData,data:Data.value})
               .then((res) => {
                   
                   if(res.data.success){
                   toast({
                       component: ToastificationContent,
                       position: 'top-right',
                       props: {
                       title: `Success`,
                       icon: 'BellIcon',
                       variant: 'success',
                       text: `${res.data.message}`,
                       },
                   });
                   emit('refetch-data')
                   emit('update:is-socials-form-sidebar-active', false)
                   }else{
                   
                   toast({
                       component: ToastificationContent,
                       position: 'top-right',
                       props: {
                       title: `Error`,
                       icon: 'BellIcon',
                       variant: 'danger',
                       text: `${res.data.message}`,
                       },
                   });
               
                   
                   }
               
               })
           }else{
               store.dispatch('app-socials/addSocials', {formData:formData})
               .then((res) => {
                   
                   if(res.data.success){
                   toast({
                       component: ToastificationContent,
                       position: 'top-right',
                       props: {
                       title: `Success`,
                       icon: 'BellIcon',
                       variant: 'success',
                       text: `${res.data.message}`,
                       },
                   });
                   emit('refetch-data')
                   emit('update:is-socials-form-sidebar-active', false)
                   }else{
                   
                   toast({
                       component: ToastificationContent,
                       position: 'top-right',
                       props: {
                       title: `Error`,
                       icon: 'BellIcon',
                       variant: 'danger',
                       text: `${res.data.message}`,
                       },
                   });
               
                   
                   }
               
               })
           }

       }

       
        const {
       refFormObserver,
       getValidationState,
       resetForm,
     } = formValidation(resetData)
     //upload
     const refInputEl = ref(null)
      const refPreviewEl = ref(null)

      
     const { inputImageRenderer } = useInputImageRenderer(refInputEl, base64 => { 
        //console.log('refInputEl',refInputEl);
        refPreviewEl.value.src = base64 
     })

      const refInputBannerEl = ref(null);
     const refBannerEl = ref(null)
     
     const { inputBannerRenderer } = useInputImageRenderer(refInputBannerEl, base64 => { 
     
        refBannerEl.value.src = base64 
    })
    const refInputLogoEl = ref(null);
     const refLogoEl = ref(null)
    const { inputLogoRenderer } = useInputImageRenderer(refInputLogoEl, base64 => { 
    
      refLogoEl.value.src = base64 
    })


    
     const revomeImage = ()=>{
      Data.value.featuredImage = require('@/assets/images/no-image.png');
      Data.value.cover_image = '';
     }
     const revomeBanner = ()=>{
      Data.value.bannerImage = require('@/assets/images/no-image.png');
      Data.value.banner_image = '';
     }

     const revomeLogo = ()=>{
      Data.value.logoImage = require('@/assets/images/no-image.png');
      Data.value.logo_image = '';
     }
     const changeTitle  = () => {
        Data.value.slug =  slugify(Data.value.title )
       }
     return {
       Data,
       onSubmit,
       catsData,
       refFormObserver,
       getValidationState,
       resetForm,
       getData,

       refInputEl,   
       refPreviewEl,
       inputImageRenderer,
       revomeImage,

       refInputBannerEl,
       refBannerEl,
       inputBannerRenderer,
       revomeBanner,

       refInputLogoEl,
       refLogoEl,
       inputLogoRenderer,
       revomeLogo,
       

       tabIndex,
       changeTitle
       
     }
  
   }
   
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/quill.scss';
</style>